var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawerMenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.20483L5.8 6.00483L1 10.8048",
    stroke: "#005A2B",
    strokeWidth: 1.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerMenuArrow);
export default __webpack_public_path__ + "static/media/drawerMenuArrow.901dde236e48cf6f33908ebec8b4ae07.svg";
export { ForwardRef as ReactComponent };